export const SEND_EMAIL_MESSAGE = {
	ERROR: 'We could not send emails, please try again later.',
	SUCCESS: 'Email was successfully sent.',
	SEND_ALL_SUCCESS: 'Emails have successfully been sent.',
};
